<template>
  <div class="subscription">
    <a-tabs v-model:activeKey="tabType">
      <a-tab-pane :key="1" tab="默认"></a-tab-pane>
      <a-tab-pane :key="2" tab="初次"></a-tab-pane>
      <a-tab-pane :key="3" tab="重新"></a-tab-pane>
    </a-tabs>
    <div v-if="tabType === 1">
      <div class="df">
        <div>
          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>订阅文案-PC：</div>
            <quillEditor
              v-model:value="popupSet1.pcText"
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>订阅文案-M：</div>
            <quillEditor
              v-model:value="popupSet1.mText"
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>订阅按钮：</div>
            <a-input
              v-model:value="popupSet1.buttonText"
              placeholder="请输入"
              @change="
                () => inputLengthCut(popupSet1.buttonText, 'buttonText', 1)
              "
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">Cookie提示：</div>
            <quillEditor
              v-model:value="popupSet1.cookieText"
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>图片：</div>
            <div class="df">
              <div class="mr20">
                <div class="w120 h120 mb10 pr">
                  <a-upload-dragger
                    :fileList="[]"
                    :show-upload-list="false"
                    name="file"
                    :multiple="true"
                    :customRequest="e => upload(e, 1, 'pc')"
                    :accept="'.png,.jpg,.jpeg,.gif'"
                    :headers="uploadHeaders"
                  >
                    <div v-if="['', null].includes(popupSet1.pcImgUrl)">
                      <div
                        class="w120 h120 tac"
                        style="color: #666666; font-size: 40px; line-height: 120px;"
                      >
                        <PictureOutlined />
                      </div>
                    </div>
                  </a-upload-dragger>
                  <div
                    v-if="!['', null].includes(popupSet1.pcImgUrl)"
                    class="h120 pa l0 t0 sidebarContentBg"
                    :style="
                      `width: 120px; background: url('${popupSet1.pcImgUrl}') center center/ cover no-repeat;`
                    "
                  >
                    <div class="hover">
                      <EyeOutlined
                        @click="
                          () => changeVisiblePic(true, popupSet1.pcImgUrl)
                        "
                      />
                      &nbsp;&nbsp;
                      <DeleteOutlined @click="popupSet1.pcImgUrl = null" />
                    </div>
                  </div>
                </div>
                <div class="tac">PC端(三倍图)</div>
                <div class="tac">1170 × 1560</div>
                <MaterialSelectionListModal
                  style="margin: 10px"
                  @submit="val => handleSubmit(val, 1, 'pc')"
                  :validateImageOrVideoArea="['390*520']"
                  :validateImageOrVideoFormatAndSizeByMB="{
                    jpg: 0.5,
                    png: 0.5,
                    gif: 10,
                    jpeg: 0.5,
                    'image/jpeg': 0.5,
                    'image/png': 0.5,
                    'image/gif': 10,
                    'image/jpg': 0.5
                  }"
                  :fileterResourceType="1"
                  :siteId="Number(queryParams?.siteId)"
                  :terminalId="Number(queryParams?.terminalId)"
                  :subTerminalId="Number(queryParams?.terminalId)"
                />
              </div>
              <div>
                <div class="w120 h120 mb10 pr">
                  <a-upload-dragger
                    :fileList="[]"
                    :show-upload-list="false"
                    name="file"
                    :multiple="true"
                    :customRequest="e => upload(e, 1, 'm')"
                    :accept="'.png,.jpg,.jpeg,.gif'"
                    :headers="uploadHeaders"
                  >
                    <div v-if="['', null].includes(popupSet1.mImgUrl)">
                      <div
                        class="w120 h120 tac"
                        style="color: #666666; font-size: 40px; line-height: 120px;"
                      >
                        <PictureOutlined />
                      </div>
                    </div>
                  </a-upload-dragger>
                  <div
                    v-if="!['', null].includes(popupSet1.mImgUrl)"
                    class="h120 pa l0 t0 sidebarContentBg"
                    :style="
                      `width: 120px; background: url('${popupSet1.mImgUrl}') center center/ cover no-repeat;`
                    "
                  >
                    <div class="hover">
                      <EyeOutlined
                        @click="() => changeVisiblePic(true, popupSet1.mImgUrl)"
                      />
                      &nbsp;&nbsp;
                      <DeleteOutlined @click="popupSet1.mImgUrl = null" />
                    </div>
                  </div>
                </div>
                <div class="tac">M端(三倍图)</div>
                <div class="tac">873 × 456</div>
                <MaterialSelectionListModal
                  style="margin: 10px"
                  @submit="val => handleSubmit(val, 1, 'm')"
                  :validateImageOrVideoArea="['291*152']"
                  :validateImageOrVideoFormatAndSizeByMB="{
                    jpg: 0.5,
                    png: 0.5,
                    gif: 10,
                    jpeg: 0.5,
                    'image/jpeg': 0.5,
                    'image/png': 0.5,
                    'image/gif': 10,
                    'image/jpg': 0.5
                  }"
                  :fileterResourceType="1"
                  :siteId="Number(queryParams?.siteId)"
                  :terminalId="Number(queryParams?.terminalId)"
                  :subTerminalId="2"
                />
              </div>
            </div>
            <div class="w500 mb20 mt20">
              <div class="mb4">着陆页链接：</div>
              <a-input
                v-model:value="popupSet1.imgJumpUrl"
                placeholder="请输入"
              />
            </div>
            <div class="w500 mb20 mt20">
              <div class="mb4">是否展示偏好：</div>
              <a-radio-group
                name="radioGroup"
                v-model:value="popupSet1.showPersonalPreference"
              >
                <a-radio :value="true">是</a-radio>
                <a-radio :value="false">否</a-radio>
              </a-radio-group>
            </div>
          </div>
        </div>
        <div class="EditContainerRight">
          <div class="checkPicTabs mb20">
            <div
              :class="`checkPicTab ${checkPic === 1 ? 'check' : ''}`"
              @click="() => checkPicChange(1)"
            >
              PC端
            </div>
            <div
              :class="`checkPicTab ${checkPic === 2 ? 'check' : ''}`"
              @click="() => checkPicChange(2)"
            >
              M端
            </div>
          </div>
          <div
            class="pic checkPics"
            :style="
              `background: url(${
                checkPic === 1
                  ? popupSet1.showPersonalPreference
                    ? p4
                    : pc1
                  : popupSet1.showPersonalPreference
                  ? m4
                  : m1
              }) center top/contain no-repeat;`
            "
          ></div>
        </div>
      </div>
    </div>
    <div v-if="tabType === 2">
      <div class="df">
        <div>
          <div class="w500 mb20">
            <div class="mb4">
              <span class="red">*</span>初次订阅成功文案-PC：
            </div>
            <quillEditor
              v-model:value="popupSet2.pcText"
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              <span class="red">*</span>初次订阅成功文案-M：
            </div>
            <quillEditor
              v-model:value="popupSet2.mText"
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>初次订阅成功按钮：</div>
            <a-input
              class="w300 mb10"
              v-model:value="popupSet2.buttonText"
              placeholder="请输入"
              @change="
                () => inputLengthCut(popupSet2.buttonText, 'buttonText', 2)
              "
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">初次订阅成功URL：</div>
            <a-input
              class="w300 mb10"
              v-model:value="popupSet2.subSuccessUrl"
              placeholder="请输入"
              :maxlength="500"
            />
          </div>
          <div class="w500 mb20 mt20">
            <div class="mb4">是否展示偏好：</div>
            <a-radio-group
              name="radioGroup"
              v-model:value="popupSet2.showPersonalPreference"
            >
              <a-radio :value="true">是</a-radio>
              <a-radio :value="false">否</a-radio>
            </a-radio-group>
          </div>
          <div></div>
        </div>
        <div class="EditContainerRight">
          <div class="checkPicTabs mb20">
            <div
              :class="`checkPicTab ${checkPic === 1 ? 'check' : ''}`"
              @click="() => checkPicChange(1)"
            >
              PC端
            </div>
            <div
              :class="`checkPicTab ${checkPic === 2 ? 'check' : ''}`"
              @click="() => checkPicChange(2)"
            >
              M端
            </div>
          </div>
          <div
            class="pic checkPics"
            :style="
              `background: url(${
                checkPic === 1 ? pc2 : m2
              }) center top/contain no-repeat;`
            "
          ></div>
        </div>
      </div>
    </div>
    <div v-if="tabType === 3">
      <div class="df">
        <div>
          <div class="w500 mb20">
            <div class="mb4">
              <span class="red">*</span>重新订阅成功文案-PC：
            </div>
            <quillEditor
              v-model:value="popupSet3.pcText"
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              <span class="red">*</span>重新订阅成功文案-M：
            </div>
            <quillEditor
              v-model:value="popupSet3.mText"
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>重新订阅成功按钮：</div>
            <a-input
              class="w300 mb10"
              v-model:value="popupSet3.buttonText"
              @change="
                () => inputLengthCut(popupSet3.buttonText, 'buttonText', 3)
              "
              placeholder="请输入"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">重新订阅成功URL：</div>
            <a-input
              class="w300 mb10"
              v-model:value="popupSet3.subSuccessUrl"
              placeholder="请输入"
              :maxlength="500"
            />
          </div>
          <div class="w500 mb20 mt20">
            <div class="mb4">是否展示偏好：</div>
            <a-radio-group
              name="radioGroup"
              v-model:value="popupSet3.showPersonalPreference"
            >
              <a-radio :value="true">是</a-radio>
              <a-radio :value="false">否</a-radio>
            </a-radio-group>
          </div>
          <div></div>
        </div>
        <div class="EditContainerRight">
          <div class="checkPicTabs mb20">
            <div
              :class="`checkPicTab ${checkPic === 1 ? 'check' : ''}`"
              @click="() => checkPicChange(1)"
            >
              PC端
            </div>
            <div
              :class="`checkPicTab ${checkPic === 2 ? 'check' : ''}`"
              @click="() => checkPicChange(2)"
            >
              M端
            </div>
          </div>
          <div
            class="pic checkPics"
            :style="
              `background: url(${
                checkPic === 1 ? pc3 : m3
              }) center top/contain no-repeat;`
            "
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { quillEditor } from 'vue3-quill'
import { toRefs, inject, reactive } from 'vue'
import {
  DeleteOutlined,
  EyeOutlined,
  PictureOutlined
} from '@ant-design/icons-vue'
export default {
  components: {
    quillEditor,
    DeleteOutlined,
    EyeOutlined,
    PictureOutlined
  },
  setup() {
    const state = reactive({
      checkPicChange: (checkPic = 1) => {
        state.checkPic = checkPic
      },
      checkPic: 1,
      pc1:
        'https://cdn-image.kapeixi.cn/web/4e913795-3c31-40e5-9835-b985a9a5af87/PC-01.png',
      pc2:
        'https://cdn-image.kapeixi.cn/web/a5f6ca72-131a-45f2-8611-70216e086906/PC-02.png',
      pc3:
        'https://cdn-image.kapeixi.cn/web/c192e945-8453-4bc1-a2e9-3e82bd565bac/PC-03.png',
      p4:
        'https://cdn-image.kapeixi.cn/web/a71316eb-ca9d-4601-a21a-0bada1ea2a05/PC1.png',
      m1:
        'https://cdn-image.kapeixi.cn/web/26e91153-754e-4fce-93e1-4beb90a4e504/m-01.png',
      m2:
        'https://cdn-image.kapeixi.cn/web/1a6d9470-fc06-403c-a6ba-549651618cdb/m-02.png',
      m3:
        'https://cdn-image.kapeixi.cn/web/fdc8e197-e511-4e3a-84f2-b94610ed1398/m-03.png',
      m4:
        'https://cdn-image.kapeixi.cn/web/2c4ac2f0-75b8-49bf-b6b6-2ab03d4268f1/M1.png'
    })

    return {
      ...toRefs(state),
      ...toRefs(inject('initState')),
      editorOption: {
        placeholder: '请输入',
        modules: {
          toolbar: [
            [
              {
                font: [
                  'Muli-Light',
                  'Muli-SemiBold',
                  'Muli-Bold',
                  'Muli-ExtraBold'
                ]
              }
            ],
            [
              {
                size: [
                  '12px',
                  '14px',
                  '16px',
                  '18px',
                  '20px',
                  '22px',
                  '24px',
                  '26px',
                  '28px',
                  '30px',
                  '32px',
                  '34px',
                  '36px',
                  '38px',
                  '40px'
                ]
              }
            ],
            ['bold', 'link'],
            [
              {
                color: [
                  'red',
                  'blue',
                  'green',
                  'black',
                  'yellow',
                  'pink',
                  'white',
                  '#14AA6E'
                ]
              }
            ]
          ]
        }
      }
    }
  }
}
</script>
<style scoped>
.checkPicTabs {
  width: 146px;
  height: 36px;
  background: #f0f0f0;
  display: flex;
  padding: 3px;
  border-radius: 3px;
  margin: 0 auto 20px auto;
}

.checkPicTab {
  width: 70px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 3px;
  cursor: pointer;
}

.checkPicTab.check {
  background: #ffffff;
}

.EditContainerRight {
  background: #f4f4f4;
  width: 400px;
  padding: 14px;
  margin: 14px;
}

.checkPics {
  height: 560px;
}
.sidebarContentBg .hover {
  width: 120px;
  height: 120px;
  display: none;
  cursor: pointer;
  color: #ffffff;
  text-align: center;
  line-height: 120px;
  background: rgba(0, 0, 0, 0.3);
}

.sidebarContentBg:hover .hover {
  display: block;
}
</style>
<style>
.subscription .ant-upload.ant-upload-drag .ant-upload {
  padding: 0;
}
</style>
